import SectionHeading from '@/components/base/SectionHeading';
import { siteInfo, testimonials } from '@/mocks/home';

const principles = [
  { id: 'p-1', icon: 'ri-user-heart-line', title: '不评判具体的人', desc: '我们聊现象、聊心理，不把矛头指向任何真实的个体。' },
  { id: 'p-2', icon: 'ri-shield-check-line', title: '不传播未经核实的信息', desc: '拿不准的事，我们宁可少写一句，也不添一句。' },
  { id: 'p-3', icon: 'ri-emotion-laugh-line', title: '保持幽默感', desc: '轻松是一种态度，但没有分寸的玩笑我们不开。' },
  { id: 'p-4', icon: 'ri-heart-3-line', title: '尊重每一位读者', desc: '看得开心、看得明白、看完不焦虑，是我们的底线。' },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="rounded-lg overflow-hidden w-full h-[260px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20cozy%20reading%20corner%20with%20a%20wooden%20table%2C%20watermelon%20slices%2C%20a%20notebook%20and%20a%20cup%20of%20tea%2C%20cream%20background%20with%20soft%20green%20plants%20and%20coral%20accents%2C%20flat%20vector%20editorial%20style&width=1000&height=800&seq=guitian-about-2026&orientation=landscape"
              alt="关于瓜田吃瓜：温馨的阅读角落插画，桌上有西瓜与笔记本"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="我们想做一个「说得清」的围观现场"
              desc={siteInfo.intro}
            />
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              {siteInfo.name}诞生于一个很朴素的观察：我们每天都在围观，却很少认真想过自己为什么爱看。
              于是我们决定一边更新段子与表情包，一边把这些说不清的感觉拆开来讲。
              网站定位很简单——做一份有解释力的围观读物，让你笑完之后，还能多一点自我了解。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-primary-50 border border-primary-200 p-4">
                <p className="font-heading text-xl md:text-2xl text-primary-700">轻松但认真</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">发展理念</p>
              </div>
              <div className="rounded-lg bg-accent-50 border border-accent-200 p-4">
                <p className="font-heading text-xl md:text-2xl text-accent-700">有梗有依据</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">内容追求</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="font-heading text-xl md:text-2xl text-foreground-950">我们的内容原则</h3>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {principles.map((item) => (
              <article key={item.id} className="rounded-lg bg-background-100 border border-background-200 p-5">
                <span className="w-11 h-11 rounded-lg bg-secondary-100 text-secondary-800 flex items-center justify-center text-xl">
                  <i className={item.icon} />
                </span>
                <h4 className="mt-3 font-heading text-base text-foreground-950">{item.title}</h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="font-heading text-xl md:text-2xl text-foreground-950">读者怎么说</h3>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {testimonials.map((item) => (
              <figure key={item.id} className="rounded-lg bg-background-100 border border-background-200 p-5 flex flex-col">
                <i className="ri-double-quotes-l text-2xl text-primary-300" />
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 pt-3 border-t border-background-200">
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}